import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'


import SearchInput from 'react-search-input'
import {segmentEventTracker} from 'common/analytics'
import {search} from 'broker/redux/account'

import { selectAccountSearchTerm } from 'broker/selectors/account'

const AgentListSearch = (props) => {
  const { searchTerm, search } = props

  return <div className="AgentList">
    <div className="AgentList__download" onClick={() => {
      segmentEventTracker('Data Downloaded', { 'downloaded_data': 'agent_pipeline' })
    }}><a href="/download/agents"><i className="fa fa-download" aria-hidden="true"/> Download</a></div>
    <SearchInput
      className="SearchInput glyphicon glyphicon-search"
      value={searchTerm}
      onChange={search}
      onClick={() => { segmentEventTracker('User Searched', { 'user_type': 'agent' }) }}
    />
  </div>
}

const mapStateToProps = createStructuredSelector({
  searchTerm: selectAccountSearchTerm
})

const mapDispatchToProps = dispatch => ({
  dispatch,
  search: searchTerm => dispatch(search({searchTerm}))
})

export default connect(mapStateToProps, mapDispatchToProps)(AgentListSearch)
